"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubCombienTempsRealisezInvestissementsCorporationTrads = void 0;
exports.ESubCombienTempsRealisezInvestissementsCorporationTrads = {
    between_10_15_ans: "Entre 10 et 15 ans",
    between_5_10_ans: "Entre 5 et 10 ans",
    greater_15_ans: "Plus de 15 ans",
    less_5_ans: "Moins de 5 ans",
};
